import React, { Fragment, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { message } from 'antd';
import { Redirect } from 'react-router-dom';

import EditableTitle from './EditableTitle';
import {
  FUTURE_PRACTICE,
  PAST_PRACTICE,
  CONTROLLER_SET, FIELD_TYPE, CONFIRMATION_MODAL_CONFIG
} from '../../../config/constants';
import { isEmptyObject, text_truncate, shouldDisplayDeletePracticeButton } from '../../../helpers/helpers';
import TabSelector from '../../Shared/Filters/TabSelector';
import ConfirmationModal from '../../Shared/Modals/ConfirmationModal';
import { SERVER } from '../../../config/server.config';
import { cleanControllerSet } from '../../../helpers/helpers';
import { selectIntensitiesByTeam, useDataEventsState, usePracticeDataUpdateDispatch, useProfilesState, useUserState } from 'store/hooks';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';
import { useManageDispatch } from 'store/hooks/manage';
import { useEventsDispatch, useEventsState } from 'store/hooks/events';
import { Drill, Manage } from 'config/commonTypes';
import { Profile } from 'components/Profiles/types';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducers';
import { SimpleMultiSelectorPresentational } from 'components/Shared/Filters/SimpleMultiSelector';
import { buildIntensityFilter } from 'helpers';

type PracticeHeaderProps = {
  editable: boolean;
  shouldSave: boolean;
  currentPractice: Manage;
  setCurrentPractice: React.Dispatch<React.SetStateAction<Manage>>;
  savable: boolean;
  newPractice: (practice: Manage) => Manage;
  setEditable: React.Dispatch<React.SetStateAction<boolean>>;
  updateQueue: { queue:any[];fetching: number; };
}
const PracticeHeader =  ({
                  editable, currentPractice, setCurrentPractice, savable, newPractice, setEditable, updateQueue, shouldSave,
                }:PracticeHeaderProps) => {
  const user = useUserState();
  const { dataEvent:practice = undefined, data:manageData, meta, mongoId } = useDataEventsState();
  const practiceManage = manageData?.manage;
  const eventId = meta?._id;
  const league = meta?.league;
  const { profiles: allProfiles } = useProfilesState();
  const profiles = allProfiles[practice?.meta.homeTeam.teamId as string] || [];
  const { practiceSaved } = useFlagsState();
  const  editableFlag = useSelector((state: RootState) => state.practiceDataUpdate.editableFlag);
  const { updatePractice, endPractice, finalizeCombine } = useManageDispatch();
  const { noSave } = usePracticeDataUpdateDispatch();
  const { changePracticeSavedSuccessfullyFlag } = useFlagsDispatch();
  const hidePracticeSavedMessage = () => {
    changePracticeSavedSuccessfullyFlag(false);
  };
  const { loadEvents } = useEventsDispatch();
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;

  const [closeModalContent, setCloseModalContent] = useState(0);
  const [show, setShow] = useState(-1);
  const [intensity, setIntensity] = useState('');
  const [intensityArray, setIntensityArray] = useState<string[]>([]);
  const close = () => setShowFilter(-1);
  const [showFilter, setShowFilter] = useState(0);
  const [modalShow, setModalShow] = useState(0); // 0 nothing, 1 end practice, 2 delete, 3 save
  const [redirect, setRedirect] = useState(false);
  const intensities = useSelector(
  selectIntensitiesByTeam(meta.homeTeam.teamId)
);
const intensityFilter = buildIntensityFilter(intensities?? []);

const currentTypes = (currentPractice.intensity ?? '')
  .split(',')
  .map(type => type.trim())
  .filter(Boolean)
  .map(type => ({ value: type, name: type }));

const missingTypes = currentTypes.filter(
  selItem => !intensityFilter.types.some(t => t.value === selItem.value)
);

const updatedIntensityFilter = {
  ...intensityFilter,
  types: [...missingTypes, ...intensityFilter.types],
};
  if (redirect) {
    return <Redirect to="/" />;
  }
  const handleEditingChange = () => {
    if(editable && shouldSave && savable){
      showModalSavePractice();
    }else{
      setCurrentPractice(newPractice(practiceManage));
      noSave(false);
      setEditable(!editable);
    }
    if (!editable) { // if changing to editing mode, clean all controllers
      cleanControllerSet(CONTROLLER_SET);
    }

  };

  const handleSaveClick = () => {
    noSave(false);
    setEditable(false);
    cleanControllerSet(CONTROLLER_SET);
    updatePractice(currentPractice, eventId, league, meta.type, true, undefined, isMobile);
  };

  if (practiceSaved) {
    // show message and then clear flags
    message.success({
      content: 'Practice Successfully Saved',
      className: 'message-pro',
      style: {
        marginTop: '60vh'
      }
    }, 10);
    hidePracticeSavedMessage();
  }

  const showModalEndPractice = () =>{
    setModalShow(1);
    setCloseModalContent(1);};
  const showModalDeletePractice = () => {
    setModalShow(2);
    setCloseModalContent(2);};
  const showModalSavePractice = () => {
    setModalShow(3);
    setCloseModalContent(3);};
    const showModalEndPracticeEvents = () =>{
      setModalShow(4);
      setCloseModalContent(4);};

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    noSave(true);
    if (event.target.value !== ' ') {
      setCurrentPractice({ ...currentPractice, name: event.target.value });
    }
  };
  const handleDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    noSave(true);
    if (event.target.value !== ' ') {
      setCurrentPractice({ ...currentPractice, description: event.target.value });
    }
  };
  const handleIntensityChange = (value:string[]) => {
    noSave(true);
    let intensities='';
    value.forEach((value, index)=>{
      intensities= index === 0? value : intensities+','+value;
    });
    setIntensity(intensities);
    setCurrentPractice({ ...currentPractice, intensity: intensities });
  };
  const handleProfilesChange = (profile:Profile) => {
    noSave(true);
    const newDrills = JSON.parse(JSON.stringify(profile.drills));
    setCurrentPractice({
      ...currentPractice,
      drills: newDrills.map((drill:Drill, index:number) => ({ ...drill, drillId: index })),
      profileName: profile.profileName
    });
  };

  const profilesItems = !profiles ? [] :
    profiles.map((profile, index) => (
      <Dropdown.Item key={index} onClick={() => handleProfilesChange(profile)}>
        {profile.profileName}
      </Dropdown.Item>));

  let intensityDropdownText = '';
  if (currentPractice && currentPractice.intensity && currentPractice.intensity.length !== 0) {
    intensityDropdownText = currentPractice.intensity;
  }

  let profileDropdownText = 'Select';
  if (currentPractice && currentPractice.profileName) {
    profileDropdownText = currentPractice.profileName;
  }
  const profileToggleDisabled = practice?.meta.type !== FUTURE_PRACTICE || !editable;
  const modalClose = () => {
    setModalShow(0);
    setCurrentPractice(newPractice(practiceManage));
    noSave(false);

  };

  // NEEDS TO BE REMADE!!!
  const handleDeletePractice = () => {
    const teamId = practiceManage.teamId;
    const request = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    };
    if (!mongoId) {
      alert('The practice could not be deleted');
    } else {
      setRedirect(true);
      fetch(SERVER.MANAGE_DELETE(mongoId, teamId, practiceManage.league), request)
        .then(data => data.json())
        .then(jsonData => {
        })
        .catch(e => {
          console.error(e);
        })
        .then(data => {
          loadEvents(true, false, true, true);
        });
    }
  };
  const handleDeleteConfirmation = () => {
    cleanControllerSet(CONTROLLER_SET);
    // cleanArrayControllers(MANAGE_TAB_CONTROLLERS);
    handleDeletePractice();
  };

  const handleEndPractice = () => {
    cleanControllerSet(CONTROLLER_SET);
    if('combineEvents' in currentPractice && currentPractice.combineEvents?.length !== 0){
      finalizeCombine(currentPractice.dataset_id);
    }
    endPractice(practiceManage, practiceManage.drills, isMobile);
  };

  const deleteModalContent = {
    headerContent: ' ',
    bodyContent: 'Are you sure you want to delete this practice?',
    confirmContent: 'Yes, Delete Practice'
  };
  const runingEventsModalContent = {
    headerContent: ' ',
    bodyContent: 'Make sure you end all events before ending this practice',
    confirmContent: 'Ok'
  };
  const endPracticeModalContent = {
    headerContent: ' ',
    bodyContent: (
      <>
        Are you sure you want to end this practice?
        {JSON.stringify(currentPractice) !== JSON.stringify(newPractice(practiceManage)) && (
          <div className="warning-text">There are unsaved changes, they will be lost.</div>
        )}
      </>
    ),
    confirmContent: 'Yes, End Practice'
  };
  const savingModalContent = {
    headerContent: ' ',
    bodyContent: (
      <>
        Would you like to save your changes?
          <div className="warning-text">There are unsaved changes, they will be lost.</div>

      </>
    ),
    confirmContent: 'Yes, Save Changes'
  };
  return (

    <Fragment>
      { 
      modalShow === 4 ?(
        <ConfirmationModal
        show={modalShow}
        onHide={modalClose}
        modalConfig={{
          ...CONFIRMATION_MODAL_CONFIG,
          confirmClassName: 'm-save-entity-confirm' } }
        modalContent={runingEventsModalContent }
        confirmAction={modalClose}
      />
      ):
      modalShow === 3 ?(
        <ConfirmationModal
        show={modalShow}
        onHide={()=>{setEditable(!editable);
          modalClose();}}
        modalConfig={{
          ...CONFIRMATION_MODAL_CONFIG,
          confirmClassName: 'm-save-entity-confirm' } }
        modalContent={savingModalContent }
        confirmAction={handleSaveClick}
      />
      ):
      <ConfirmationModal
      show={modalShow}
      onHide={modalClose}
      modalConfig={modalShow === 1 ? {
        ...CONFIRMATION_MODAL_CONFIG,
        confirmClassName: CONFIRMATION_MODAL_CONFIG.confirmClassName + (JSON.stringify(currentPractice) !== JSON.stringify(newPractice(practiceManage)) ? ' end-practice-disabled' : '')
      } : modalShow === 2 ? CONFIRMATION_MODAL_CONFIG : closeModalContent === 3 ? {...CONFIRMATION_MODAL_CONFIG, confirmClassName: 'm-save-entity-confirm' } : {...CONFIRMATION_MODAL_CONFIG}}
      modalContent={modalShow === 1 ? endPracticeModalContent : closeModalContent === 2 ? deleteModalContent : closeModalContent === 3 ? savingModalContent : endPracticeModalContent }
      confirmAction={modalShow === 1 ? handleEndPractice : handleDeleteConfirmation}
    />}

      <TabSelector show={show === 1} open={() => setShow(1)} close={() => setShow(-1)} />
      <EditableTitle
        editable={editable} text={currentPractice ? currentPractice.name : ''}
        handleChange={handleNameChange} title="Practice Name" style={{ marginLeft: '167px' }}
      />
      <EditableTitle
        editable={editable} text={currentPractice ? currentPractice.description : ''}
        handleChange={handleDescriptionChange} title="Practice Description"
      />
      <div className="manage-p">
        <p>Profile</p>
        <Dropdown className="select-00 profile-dropdown">
          <Dropdown.Toggle id="dropdown-basic" disabled={profileToggleDisabled}>
            {text_truncate(profileDropdownText, 10)}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {profilesItems}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className="manage-p">
        <p>Intensity</p>
        <SimpleMultiSelectorPresentational
            show={showFilter === 3}
            close={close}
            open={() => setShowFilter(3)}
            filterData={!currentPractice || !currentPractice.intensity? [] : typeof JSON.parse(JSON.stringify(currentPractice.intensity)) === 'string'? 
            currentPractice.intensity.split(',').map((type) => ({ value: type, name: type })):
            currentPractice.intensity.split(',').map((type) => ({ value: type, name: type }))}
            changeFilterData={(values) => {
              setIntensityArray(values.map(val => val.value));
              handleIntensityChange(values.map(val => val.value));}}
            type={updatedIntensityFilter}
            forceScope={'INTENSITY_DROPDOWN_HEADER'}
            editable={!editable}
          />
      </div>
      <div className="manage-p">
        <p>Field Type</p>
        <Dropdown
          className="inte-00 field-type-dropdown"
          onSelect={(event) => {
            noSave(true);
            setCurrentPractice({ ...currentPractice, rooftype: event as string });}}
        >
          <Dropdown.Toggle id="dropdown-basic" disabled={!editable}>
            {text_truncate(currentPractice.rooftype, 13) || 'Select'}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {FIELD_TYPE.types.map((field, index) => (
              <Dropdown.Item eventKey={field} key={field}>{field}</Dropdown.Item>))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className="manage-p">
      </div>
      <div className="manage-btn">
        <div className={'switch-00' + (isEmptyObject(currentPractice) ? ' box-disabled' : '')}>
          <label className="label-009" onClick={()=>{handleEditingChange();}}>{'Editing ' + (editable ? 'Unlocked' : 'Locked')}</label>
          <input
            type="checkbox" id="editing-practice-manager" name="set-name" className="switch-input"
            checked={ editableFlag}
            onChange={() => handleEditingChange()}
          />
          <label htmlFor="editing-practice-manager" id="editing-practice-manager-label" className="switch-label" />
        </div>
        <button
          className={'btn-green'} onClick={() => handleSaveClick()}
          style={savable && editable ? {} : {opacity: 0.5, cursor: 'default', pointerEvents: 'none'}}
        >
          Save
        </button>
        {practice?.meta.type !== PAST_PRACTICE ?
          <button
            className="btn-red"
            onClick={() => {
              let hasFutureDrill = false;
              const now = (new Date()).getTime();
              currentPractice.drills.forEach(drill => {
                if (drill.startTs > now || drill.endTs > now) {
                  hasFutureDrill = true;
                }
              });
              if (hasFutureDrill) {
                message.error({
                  content: 'Please adjust the practice time stamps before ending the practice',
                  className: 'antd-message-alert'
                }, 10);
                return;
              }
              if('combineEvents' in currentPractice && currentPractice.combineEvents?.length !== 0 &&  
                (currentPractice.combineEvents?.find(e=>e.id === 'drillOnest') || currentPractice.combineEvents?.find(e=>e.id === 'drillTwost') )){
                  showModalEndPracticeEvents();
              }else{
                showModalEndPractice();
              }
              
            }}
            style={(practice?.meta.type === FUTURE_PRACTICE || updateQueue.queue.length > 0 || isEmptyObject(currentPractice)) ? {opacity: 0.5, cursor: 'default', pointerEvents: 'none'} : {}}
          >
            End <span className="mobile-only">Practice</span>
          </button> : null}
        {shouldDisplayDeletePracticeButton(user, practice)&&(
          <button
            className={'btn-delete' + (isEmptyObject(currentPractice) ? ' box-disabled' : '')}
            onClick={() => showModalDeletePractice()}
          >
            Delete Practice
          </button>
        )}
      </div>
    </Fragment>
  );
};
export default PracticeHeader;
